import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./creator.css";
import { trackReferral } from "./referral";

/**
 * /r/:code — every creator link and QR code lands here. Records the click
 * (or scan, when the QR adds ?s=qr), remembers the referral for checkout, then
 * sends the fan to the event page.
 */
export default function ReferralRedirect() {
  const { code } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const kind = params.get("s") === "qr" ? "scan" : "click";
    const channel = params.get("c") || (kind === "scan" ? "qr" : undefined);
    trackReferral(code, { kind, channel })
      .then((destination) => {
        if (destination) navigate(destination, { replace: true });
        else setFailed(true);
      })
      .catch(() => setFailed(true));
  }, [code, search, navigate]);

  return (
    <div className="cp" style={{ display: "grid", placeItems: "center", padding: 24, textAlign: "center" }}>
      {failed ? (
        <div>
          <p className="cp-lede">This link isn't active anymore.</p>
          <a className="cp-btn" href="/events">
            Browse events on InstaPass
          </a>
        </div>
      ) : (
        <p className="cp-lede" aria-live="polite">
          Taking you to your tickets…
        </p>
      )}
    </div>
  );
}
